<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1050"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="info" 
        v-on="on"
      >
        Edit Non ML Access
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      title="User Non ML Company Access"
      color="green"
      text="Change User Non ML Company Access"
      class="mb-0"
    >
      <v-form v-if="!loading">
        <v-container>
          <v-row>
            <v-col>
              <v-checkbox
                v-model="selectAll"
                label="Select all (PERMANENT)"
              />
            </v-col>
          </v-row>

          <v-divider />

          <v-row class="overflow">
            <v-col
              v-for="(company,index) in companies"
              :key="index"
              cols="6"
              class="py-0"
            >
              <v-checkbox
                v-model="selectedCompany"
                :label="company.name"
                :value="company.id"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      userUid: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: null,
        progressing: false,
        loading: false,
        companies: [],
        selectedCompany: [],
        searchInput: '',

        selectAll: false,

      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loadInitalData()
      },
      
      selectAll (value) {
        if (value) {
          this.selectAllCompany()
        } else {
          this.selectedCompany = []
        }
      },
    },

    methods: {
      loadInitalData () {
        this.loading = true

        Promise.all([
          this.$api.companyBranches().listNonMLCompanies(),   
          this.$api.userCompanies().list(this.userUid), 
        ])
          .then(([companies, userCompanies]) => {
            this.companies = _.orderBy(companies.data, ['name'], ['asc'])
            this.setUserCompanies(userCompanies.data)

            if (this.companies.length === this.selectedCompany.length) this.selectAll = true
            this.loading = false
          })
      },
      submitForm () {
        this.progressing = true
      
        this.$api.userCompanies().update(this.userUid, this.prepareCompanyFormData())
          .then(res => {
            if (res.status === 200) {
              this.$emit('updated')

              this.progressing = false
              this.dialog = false         
            }  
          })
      },
      prepareCompanyFormData () {
        return this.companies.map((company) => {
          return {
            id: company.id,
            is_active: this.selectedCompany.includes(company.id) ? 1 : 0,
          }
        })
      },
      setUserCompanies (userCompanies) {
        let t = JSON.parse(JSON.stringify(userCompanies))

        t.forEach((company) => {
          this.companies.forEach((c) => {
            if (c.id === company.id) {
              this.selectedCompany.push(c.id)
            } 
          })
        })
      },

      selectAllCompany () {
        this.companies.forEach(company => {
          this.selectedCompany.push(company.id)
        })
      },
    },
  }
</script>

<style scoped>
.overflow {
  overflow-y: scroll; 
  height: 50vh;
}
</style>
